import { EditOutlined, LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { notification, Pagination, Select, Spin } from "antd";
import _ from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import React from "react";
import Select2 from "react-select";

import EditTemplateConfig from "./EditTemplateConfig";
const RunningStreams = (props) => {
  const { usersList, getRunningStreamTemplates, entityId, getOrgDetails, fetchTemplateConfig, updateTemplateConfig } =
    props;
  const [load, setLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [templatesCount, setTemplatesCount] = useState(0);
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(undefined);
  const [selectedTemplateType, setSelectedTemplateType] = useState("");
  const [runningStreamTemplates, setRunningStreamTemplates] = useState([]);
  const [selectOrganization, setSelectOrganization] = useState([]);
  const [organizationLists, setOrganizationLists] = useState([]);
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [options, setoptions] = useState([]);
  const [showConfigModal, setShowConfigModal] = useState(false);

  const orgSearch = useRef(true);
  const { Option } = Select;
  const antIcon = <LoadingOutlined style={{ fontSize: 30, align: "center" }} spin />;
  useEffect(() => {
    setUserOptions(
      usersList.map((user) => {
        return { value: user.userId, label: `${user.name}-${user.email}` };
      }),
    );
  }, [usersList]);

  //Get All OrganizationsLists
  const getOrganizationsDetails = async () => {
    const { value } = await getOrgDetails({
      page_no: 1,
      pageSize: 10,
      searchQuery: organizationSearch,
    });
    if (value?.status) {
      setOrganizationLists(value?.organizations || []);
    }
  };

  useEffect(() => {
    if (orgSearch.current) {
      orgSearch.current = false;
    } else {
      const timer = setTimeout(() => {
        getOrganizationsDetails();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [organizationSearch]);

  useEffect(() => {
    const options = [];
    organizationLists &&
      organizationLists.map((org) => {
        options.push({ value: org?.organizationId, label: org?.displayName || org?.name });
      });
    setoptions(options);
  }, [organizationLists]);

  useEffect(() => {
    getOrganizationsDetails();
  }, []);

  const handleChange = (e) => {
    setSelectOrganization(e);
  };

  useEffect(() => {
    fetchRunningStreamTemplates();
  }, [selectOrganization, selectedTemplateType, activePage]);

  const fetchRunningStreamTemplates = _.debounce(async () => {
    try {
      setLoader(true);
      const response = await getRunningStreamTemplates({
        entityId: selectOrganization?.value ?? "",
        templateType: selectedTemplateType?.value ?? "",
        pageNo: activePage,
      });
      if (response.value.success) {
        setRunningStreamTemplates(response.value.data);
        setTemplatesCount(response.value.templatesCount);
      } else {
        notification["error"]({ message: "Something went wrong" });
      }
      setLoader(false);
    } catch (error) {
      notification["error"]({ message: error.message });
    }
  }, 500);
  const templateOptions = useMemo(() => {
    return [
      { label: "Reserved", value: "reserved_channel" },
      { label: "Direct", value: "direct" },
      { label: "MediaLive", value: "medialive" },
    ];
  }, []);
  const handleUserChange = (user) => {
    setSelectedUser(user);
  };
  const handleTemplateChange = (templateType) => {
    setSelectedTemplateType(templateType);
  };
  const handleReset = () => {
    setSelectOrganization([]);
    setSelectedTemplateType("");
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };
  return (
    <React.Fragment>
      <EditTemplateConfig
        open={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        onSubmit={updateTemplateConfig}
        fetchTemplateConfig={fetchTemplateConfig}
      />
      <div className="border-block">
        <div className="left-block">
          <h4 className="title-sm-t">Running streams by template </h4>
        </div>
        <br />
        <div className="row runnning-streams-filters">
          <div className="col-md-4">
            <label className="form-label">
              Organizations<span className="required"></span>
            </label>
            <Select2
              styles={{ width: "100%" }}
              // isMulti={true}
              bordered={false}
              value={selectOrganization}
              isClearable={true}
              onChange={(e) => {
                handleChange(e);
              }}
              onInputChange={(e) => {
                setOrganizationSearch(e);
              }}
              name="organization"
              options={options}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Output template type</label>
            <Select2
              bordered={false}
              name="templateType"
              value={selectedTemplateType}
              onChange={(e) => {
                handleTemplateChange(e);
              }}
              options={templateOptions}
            />
          </div>
          <div className="col-md-1">
            <button className="btn btn-primary" onClick={handleReset}>
              <ReloadOutlined className="btn-icon-left" />
              Reset
            </button>
          </div>
          <div className="col-md-3">
            <button className="btn btn-primary" onClick={() => setShowConfigModal(true)}>
              Edit Template configuration &nbsp; <EditOutlined />
            </button>
          </div>
        </div>
      </div>

      <br />
      <div className="border-block mt-3">
        <div className="table-resposive table-container user-management-table">
          {load ? (
            <div className="bg-loader-fade">
              <Spin className="fade-loader" indicator={antIcon} />
              <div className="loader-back-text"></div>
            </div>
          ) : runningStreamTemplates.length ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Template Name</th>
                  <th>Stream</th>
                  <th>Organization</th>
                  <th>Template Type</th>
                  <th>Region</th>
                </tr>
              </thead>
              <tbody>
                {runningStreamTemplates.map((template) => {
                  return (
                    <tr key={template.id}>
                      <td>{template.templateData.templateName}</td>
                      <td>{template.title}</td>
                      <td>{template.name}</td>
                      <td>{template.templateData.outputTemplateType}</td>
                      <td>{template.templateData.outputRegion}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="text-center  pt-5 pb-5">
              <h3>No template found</h3>
            </div>
          )}
        </div>
      </div>
      <Pagination
        hideOnSinglePage
        current={activePage}
        pageSize={20}
        onChange={handlePageChange}
        total={templatesCount}
        className="text-center mt-3"
      />
    </React.Fragment>
  );
};

export default RunningStreams;
